import { trackList } from "@/mocks/gossip";

const statusLabel: Record<string, { text: string; cls: string; dot: string }> = {
  done: { text: "已收录", cls: "bg-emerald-100 text-emerald-800", dot: "bg-emerald-500" },
  ing: { text: "进行中", cls: "bg-orange-100 text-orange-700", dot: "bg-orange-500" },
  wait: { text: "待补充", cls: "bg-stone-100 text-stone-600", dot: "bg-stone-400" },
};

export default function Track() {
  return (
    <section id="track" className="scroll-mt-20 bg-[#F4EDE2]">
      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="max-w-xl">
          <h2 className="flex items-center gap-2 text-xl font-extrabold text-stone-900 md:text-2xl">
            持续追踪中<i className="ri-node-tree text-orange-500"></i>
          </h2>
          <p className="mt-1.5 text-sm text-stone-600">
            几件还没尘埃落定的瓜，节点按真实时间顺序排好，事件更新会补进对应位置，多瓜连吃不跳步。
          </p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          {trackList.map((track) => (
            <article
              key={track.name}
              className="flex flex-col rounded-xl border border-stone-200/80 bg-white p-5"
            >
              <div className="flex items-start justify-between gap-3">
                <h3 className="text-base font-bold text-stone-900">{track.name}</h3>
                <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-orange-50 px-2.5 py-1 text-xs text-orange-600">
                  <i className="ri-loop-left-line"></i>追踪中
                </span>
              </div>
              <p className="mt-1.5 text-sm text-stone-500">{track.brief}</p>

              <ol className="mt-4 flex-1 space-y-0">
                {track.steps.map((step, idx) => {
                  const s = statusLabel[step.status];
                  return (
                    <li key={idx} className="relative flex gap-3 pb-4 last:pb-0">
                      {idx < track.steps.length - 1 && (
                        <span className="absolute left-[5px] top-4 h-full w-px bg-stone-200"></span>
                      )}
                      <span className={`mt-1.5 h-[11px] w-[11px] shrink-0 rounded-full ring-4 ring-white ${s.dot}`}></span>
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-medium text-stone-500">{step.date}</span>
                          <span className={`rounded px-1.5 py-0.5 text-[11px] font-medium ${s.cls}`}>{s.text}</span>
                        </div>
                        <p className="mt-1 text-sm text-stone-700">{step.desc}</p>
                      </div>
                    </li>
                  );
                })}
              </ol>

              <div className="mt-4 flex items-start gap-2 border-t border-stone-200/70 pt-3 text-xs text-stone-500">
                <i className="mt-0.5 shrink-0 ri-refresh-line text-orange-500"></i>
                <span className="line-clamp-2">{track.latest}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}